import s from './paymentOsCardForm.scss';

const cardNumberStyle = {
    base: s.pan,
    complete: s.complete,
    focus: s.focus,
    invalid: s.invalid,
};

const expiryStyle = {
    base: s.expiry,
    complete: s.complete,
    focus: s.focus,
    invalid: s.invalid,
};

const cvvStyle = {
    base: s.cvv,
    complete: s.complete,
    focus: s.focus,
    invalid: s.invalid,
};

export const fields = {
    cvv: {
        classes: cvvStyle,
        id: '#cvv',
        type: 'cvv',
    },
    expiry: {
        classes: expiryStyle,
        id: '#exp-date',
        type: 'creditCardExpiry',
    },
    pan: {
        classes: cardNumberStyle,
        id: '#card-number',
        includeCardImage: false,
        type: 'cardNumber',
    },
};
